import React, { useCallback /*, useEffect, useContext*/ } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
// import IconButton from '@material-ui/core/IconButton';
// import CloseIcon from '@material-ui/icons/Close';
// import SimpleBar from 'simplebar-react';

// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';

// import cx from 'clsx';
// import _get from 'lodash/get';
// import _set from 'lodash/set';
// import _noop from 'lodash/noop';

const styles = theme => ({
    root: {},
    // titleContainer: {
    //     display: 'flex',
    //     justifyContent: 'space-between',
    //     fontFamily: 'Roboto, sans-serif',
    //     fontWeight: '600',
    // },
    contentText: {
        color: '#111E14',
        fontSize: '1rem',
        fontWeight: 400,
    },
});

const getDefns = params => {
    const { props, handleClickOkButton } = params;
    const { classes } = props;

    const defns = {
        root: {
            maxWidth: 'md',
            disableBackdropClick: true,
            disableEscapeKeyDown: true,
        },
        okButton: {
            color: 'primary',
            onClick: handleClickOkButton,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const AfitdLoadingDialog = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    // const context = useContext(LayoutContext);
    // const xxxxxx = _get(context, 'xxxxxx');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { classes, message, children, onClose, ...otherProps } = props;
    const { paperScrollPaper: paperScrollPaperCls, content: contentCls } = classes;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback
    const handleClickOkButton = useCallback(() => {
        onClose();
    }, [onClose]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({ props, handleClickOkButton });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return (
        <Dialog {...defns.root} {...otherProps} classes={{ paperScrollPaper: paperScrollPaperCls }}>
            <DialogContent className={contentCls}>
                <DialogContentText
                    id="alert-dialog-description"
                    classes={{
                        root: classes.contentText,
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{ padding: 10 }}>
                            <CircularProgress size={50} />
                        </div>
                        <span>Loading</span>
                    </div>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
    //---------------------------------------------------------------------
};

export default withStyles(styles)(AfitdLoadingDialog);
